module.exports = __webpack_public_path__ + "static/media/ibm.77e893f5.png";